import { useEffect, useState } from 'react';
import type { AuthProviderType } from '@terra/shared-authorization';
import { getAuthProviderType } from '../utils/getAuthProviderType';

const resolveBuildTimeAuthProviderType = (): AuthProviderType =>
  getAuthProviderType();

export function useResolvedAuthProviderType(): AuthProviderType | null {
  const [providerType, setProviderType] = useState<AuthProviderType | null>(
    () => {
      if (typeof window === 'undefined') {
        return resolveBuildTimeAuthProviderType();
      }

      if (!window.electronAPI?.auth?.getConfig) {
        return resolveBuildTimeAuthProviderType();
      }

      return null;
    },
  );

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    if (!window.electronAPI?.auth?.getConfig) {
      setProviderType(resolveBuildTimeAuthProviderType());
      return;
    }

    let cancelled = false;

    window.electronAPI.auth
      .getConfig()
      .then((config) => {
        if (cancelled) {
          return;
        }

        setProviderType(
          config?.authProvider ?? resolveBuildTimeAuthProviderType(),
        );
      })
      .catch(() => {
        if (cancelled) {
          return;
        }

        setProviderType(resolveBuildTimeAuthProviderType());
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return providerType;
}
